import { SxProps, Theme } from '@mui/material';

export const AccountTitleSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-xl)',
	color: '#2C2C2C',
	fontWeight: 800,
	textTransform: 'uppercase',
});
